"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.archiveDateRangeTranslations = {
    "en": {
        startDate: "Start Date",
        endDate: "End Date",
        cancel: "Cancel",
        apply: "Apply",
        reset: "Reset",
    },
    "de": {
        cancel: "Abbrechen",
        apply: "Anwenden",
        endDate: "Enddatum",
        reset: "Zurücksetzen",
        startDate: "Startdatum",
    },
    "nl": {
        cancel: "Annuleren",
        apply: "Toepassen",
        endDate: "Einddatum",
        reset: "Resetten",
        startDate: "Startdatum",
    },
    "it": {
        cancel: "Annulla",
        apply: "Applica",
        endDate: "Data di fine",
        reset: "Reimposta",
        startDate: "Data di inizio",
    },
    "fr": {
        cancel: "Annuler",
        apply: "Appliquer",
        endDate: "Date de fin",
        reset: "Réinitialiser",
        startDate: "Date de début",
    },
    "es": {
        cancel: "Cancelar",
        apply: "Aplicar",
        endDate: "Fecha de finalización",
        reset: "Reiniciar",
        startDate: "Fecha de inicio",
    },
    "ja": {
        cancel: "キャンセル",
        apply: "適用",
        endDate: "終了日",
        reset: "リセット",
        startDate: "開始日",
    },
    "en-GB": {
        cancel: "Cancel",
        apply: "Apply",
        endDate: "End Date",
        reset: "Reset",
        startDate: "Start Date",
    },
    "ru": {
        startDate: "Начальная Дата",
        endDate: "Конечная Дата",
        cancel: "Отменить",
        apply: "Применить",
        reset: "Сбросить",
    },
};
